export default __webpack_public_path__ + "media/src/assets/images/customer-8a276a6fd9cde4c0808aa502a6585ab1.png";